import styled from '@emotion/styled';
import { Box } from '@chakra-ui/react';
import { Text } from 'components/ui';
import { EmotionTheme } from 'theme/emotionTheme';

const CarouselContainer = styled('div')`
  overflow-x: hidden;
  width: 100%;
`;

const CarouselWrapper = styled('div')`
  display: flex;
  flex-wrap: nowrap;
  min-width: 100%;
`;

const ScrollingStrip = styled('div')<{ theme?: EmotionTheme }>`
  display: flex;
  flex-shrink: 0;
  animation: scroll-left 60s linear infinite;
  @keyframes scroll-left {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-50%);
    }
  }
`;

const ShadowCard = styled('div')`
  width: 288px;
  height: 76px;
  margin: 16px;
  padding-left: 16px;
  padding-right: 16px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
`;

export const AutoScrollCarousel = ({ cardContent }) => {
  return (
    <CarouselContainer>
      <CarouselWrapper>
        <ScrollingStrip>
          {[...cardContent, ...cardContent].map(({ text, emoji }, i) => (
            <ShadowCard key={text + i}>
              <Text
                color={'secondary.200'}
                fontSize={'16px'}
                fontWeight={500}
                flex={1}
                mr={4}
              >
                {text}
              </Text>
              <Box
                h={'48px'}
                w={'48px'}
                rounded={'full'}
                backgroundColor={'#BCC7D7'}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Text fontSize={'3xl'}>{emoji}</Text>
              </Box>
            </ShadowCard>
          ))}
        </ScrollingStrip>
      </CarouselWrapper>
    </CarouselContainer>
  );
};
